<template>
  <div id="topBar" class="text-white">
    <q-toolbar>
      <NavigationMenu :navigationMenu="navigationMenu" />
      <a data-cy="dinapsis-link" id="title" href="https://www.veolia.es/hubgrade" target="_blank">
        <q-img
          :src="require('@/assets/img/logo-cabecera-hubgrade.svg')"
          height="33px"
          width="99px"
        />
      </a>
      <span class="city-index-label">CITY INDEX</span>
      <q-space />
      <div class="navbar-right">
        <div v-if="!isCiudadano" class="suite-link">
          <a data-cy="suite-link" :href="$store.getters['NGUD/baseURLSuite']" target="_blank">SERVICIOS DIGITALES</a>
        </div>
        <span class="navbar-separator"></span>
        <UserMenu />
      </div>
    </q-toolbar>
  </div>
</template>
<script>
import { QToolbar, QImg, QSpace } from 'quasar';
import UserMenu from './UserMenu.vue';
import NavigationMenu from './NavigationMenu.vue';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import Const from '@/components/shared/helpers/Const.js';

export default {
  data () {
    return {
      navigationMenu: {},
      isDisabledODS: false,
      isDisabledAUE: false,
      isDisabledIDDIGO: false
    };
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isCiudadano: 'NGUD/isCiudadano',
      isPublicMode: 'NGUD/isPublicMode'
    })
  },
  components: {
    QToolbar,
    QImg,
    QSpace,
    UserMenu,
    NavigationMenu
  },
  created () {
    if (this.$route.params.idCiudad !== null && this.$route.params.idCiudad !== undefined) {
      this.$store.dispatch(types.ACTION_GET_CIUDAD, { idCiudad: this.$route.params.idCiudad }).then(response => {
        this.hideLoading();
      }).catch(() => { this.hideLoading(); });
    }
    this.checkVisibilityIndexCity();
    this._getMenu();
  },
  watch: {
    ciudadSelected () {
      this.checkVisibilityIndexCity();
      this._getMenu();
    }
  },
  methods: {
    _getMenu () {
      this.navigationMenu = {
        isVisible: true,
        data: [
          {
            parentTitle: 'Índices de Municipio',
            needRol: 'AdminGestorOrAccess',
            items: [
              {
                name: 'Objetivos desarrollo sostenible',
                disabled: this.isDisabledODS,
                avatar: {
                  enabled: true,
                  link: 'img/menu/agenda-2030.png',
                  size: '30px',
                  class: 'imgCenter'
                },
                link: {
                  type: 'name',
                  path: 'ods'
                }
              },
              {
                name: 'Mi Agenda Urbana',
                disabled: this.isDisabledAUE,
                avatar: {
                  enabled: true,
                  link: 'img/menu/agenda-urbana.png',
                  size: '30px',
                  class: 'imgCenter'
                },
                items: [
                  {
                    name: 'Vista general',
                    disabled: this.isDisabledAUE,
                    avatar: {
                      enabled: false
                    },
                    link: {
                      type: 'name',
                      path: 'vista-general'
                    }
                  },
                  {
                    name: 'Diagnóstico',
                    disabled: this.isDisabledAUE,
                    avatar: {
                      enabled: false
                    },
                    link: {
                      type: 'name',
                      path: 'diagnostico'
                    }
                  },
                  {
                    name: 'Plan de acción',
                    disabled: this.isDisabledAUE,
                    avatar: {
                      enabled: false
                    },
                    link: {
                      type: 'name',
                      path: 'plan-accion'
                    }
                  }
                ]
              },
              {
                name: 'Iddigo',
                disabled: this.isDisabledIDDIGO,
                avatar: {
                  enabled: true,
                  link: 'img/menu/iddigo.svg',
                  size: '30px',
                  class: 'imgCenter'
                },
                href: 'https://iddigo.com/login'
              }
            ]
          },
          {
            parentTitle: 'Índices de Municipio',
            needRol: 'Ciudadano',
            items: [
              {
                name: 'Mi Agenda Urbana',
                disabled: this.isDisabledAUE,
                avatar: {
                  enabled: true,
                  link: 'img/menu/agenda-urbana.png',
                  size: '30px',
                  class: 'imgCenter'
                },
                items: [
                  {
                    name: 'Vista general',
                    disabled: this.isDisabledAUE,
                    avatar: {
                      enabled: false
                    },
                    link: {
                      type: 'name',
                      path: 'vista-general'
                    }
                  }
                ]
              }
            ]
          },
          {
            parentTitle: 'Observatorio de indicadores',
            disabled: false,
            avatar: {
              enabled: true,
              link: 'img/menu/icon-indices-tematicos.svg',
              size: '30px',
              class: 'imgCenter'
            },
            link: {
              type: 'name',
              path: 'indices-tematicos'
            }
          },
          {
            parentTitle: 'Administración',
            needRol: 'Admin',
            items: [
              {
                name: 'Municipios',
                disabled: false,
                avatar: {
                  enabled: true,
                  link: 'img/menu/icon-cities.svg',
                  size: '30px',
                  class: 'imgCenter'
                },
                link: {
                  type: 'name',
                  path: 'ciudades'
                }
              },
              {
                name: 'Objetivos desarrollo sostenible',
                // Hasta que no se haga la administración de ODS permanece desactivo
                // disabled: this.isDisabledODS,
                disabled: true,
                avatar: {
                  enabled: true,
                  link: 'img/menu/agenda-2030.png',
                  size: '30px',
                  class: 'imgCenter'
                },
                link: {
                  type: 'name',
                  path: 'admin_ods'
                }
              },
              {
                name: 'Índices temáticos',
                disabled: false,
                avatar: {
                  enabled: true,
                  link: 'img/menu/icon-indices-tematicos.svg',
                  size: '30px',
                  class: 'imgCenter'
                },
                link: {
                  type: 'name',
                  path: 'admin_indicestematicos'
                }
              },
              {
                name: 'Indicadores',
                disabled: false,
                avatar: {
                  enabled: true,
                  link: 'img/menu/indicadores.svg',
                  size: '30px',
                  class: 'imgCenter'
                },
                link: {
                  type: 'name',
                  path: 'admin_indicadores'
                }
              }
            ]
          }
        ]
      };
    },
    checkVisibilityIndexCity () {
      if (this.ciudadSelected !== null && this.ciudadSelected.indices !== null) {
        this.isDisabledODS = (this.ciudadSelected.indices.indexOf(Const.ID_ODS) === -1);
        this.isDisabledAUE = (this.ciudadSelected.indices.indexOf(Const.ID_AUE) === -1);
        this.isDisabledIDDIGO = (this.ciudadSelected.indices.indexOf(Const.ID_IDDIGO) === -1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/style.scss";

.suite-link {
  font-family: NotoSans-Bold, sans-serif;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: #67d2df;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 10px;
}
</style>
